module.exports = __webpack_public_path__ + "img/img15.d9410287.jpg";